// =============================================================================
// MeuDriver — tela de abertura
// =============================================================================
// Logo do MeuDriver sobre o azul da marca, com um brilho que passa pelas letras
// e uma barra de progresso fina. Os estilos (.md-splash*) ficam no index.html,
// que mostra esta mesma marcação antes de o JS carregar — assim a troca para o
// React não pisca. `prefers-reduced-motion` desliga as animações.
// Substitui a antiga CarLoadingScreen (carro animado na estrada).

export function BrandLoadingScreen() {
  return (
    <div className="md-splash" role="status" aria-live="polite">
      <div className="md-splash-logo">
        <img src="/logo.png" alt="MeuDriver" width={240} height={68} />
        <span className="md-splash-shine" aria-hidden="true" />
      </div>
      <div className="md-splash-bar" aria-hidden="true">
        <span />
      </div>
      <span className="md-sr">Carregando…</span>
    </div>
  )
}

export default BrandLoadingScreen
